import _ from 'lodash'

const GET_TASKS_EMAIL_REVISION =
  'dofe-bo/emailRevisionTasks/GET_TASKS_EMAIL_REVISION'
const GET_TASKS_EMAIL_REVISION_SUCCESS =
  'dofe-bo/emailRevisionTasks/GET_TASKS_EMAIL_REVISION_SUCCESS'
const GET_TASKS_EMAIL_REVISION_FAIL =
  'dofe-bo/emailRevisionTasks/GET_TASKS_EMAIL_REVISION_FAIL'

const SET_PARAMS =
  'dofe-bo/emailRevisionTasks/SET_PARAMS'

const CLEAR_EMAIL_REVISION = 'dofe-bo/emailRevisionTasks/CLEAR_EMAIL_REVISION'
const CLEAR_EMAIL_REVISION_SUCCESS =
  'dofe-bo/emailRevisionTasks/CLEAR_EMAIL_REVISION_SUCCESS'
const CLEAR_EMAIL_REVISION_FAIL = 'dofe-bo/emailRevisionTasks/CLEAR_EMAIL_REVISION_FAIL'

const EMAIL_REVISION_ACTION = 'dofe-bo/emailRevisionTasks/EMAIL_REVISION_ACTION'
const EMAIL_REVISION_ACTION_SUCCESS =
  'dofe-bo/emailRevisionTasks/EMAIL_REVISION_ACTION_SUCCESS'
const EMAIL_REVISION_ACTION_FAIL = 'dofe-bo/emailRevisionTasks/EMAIL_REVISION_ACTION_FAIL'

const RESET_TASKS_EMAIL_REVISION =
  'dofe-bo/emailRevisionTasks/RESET_TASKS_EMAIL_REVISION'

// refactor root fields into au object
const initialState = {
  emailRevision: {
    list: [],
    detail: {},
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null,
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_EMAIL_REVISION:
      return {
        ...state,
        emailRevision: {
          ...state.emailRevision,
          loading: true
        }
      }
    case GET_TASKS_EMAIL_REVISION_SUCCESS:
      return {
        ...state,
        emailRevision: {
          ...state.emailRevision,
          loading: false,
          loaded: true,
          list: action.result,
          count: action.headers['x-total-count'],
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.emailRevision.limit
          ) || state.emailRevision.pages
        }
      }
    case GET_TASKS_EMAIL_REVISION_FAIL:
      return {
        ...state,
        emailRevision: {
          ...state.emailRevision,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case SET_PARAMS:
      return {
        ...state,
        emailRevision: {
          ...state.emailRevision,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.emailRevision.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.emailRevision.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.emailRevision.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.emailRevision.sort,
          invalidate: _.isEmpty(action.options)
            ? state.emailRevision.invalidate
            : new Date().getTime()
        }
      }
    case RESET_TASKS_EMAIL_REVISION:
      return {
        ...state,
        emailRevision: initialState.emailRevision
      }
    default:
      return state
  }
}

export function getTasksEmailRevision({ filter = null, limit, offset, sort }) {
  const query = '&filter=resolved=false,discriminator=REJECTED_EMAIL' + (filter ? `,${filter}` : '')
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = '&sort=' + (sort || '-sendDate')

  return {
    types: [
      GET_TASKS_EMAIL_REVISION,
      GET_TASKS_EMAIL_REVISION_SUCCESS,
      GET_TASKS_EMAIL_REVISION_FAIL
    ],
    promise: client =>
      client.get(
        `api/emails?getGroupedEmails=true${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function setTasksEmailRevisionParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function resetTasksEmailRevision() {
  return {
    type: RESET_TASKS_EMAIL_REVISION
  }
}

export function clearEmailRevision (id) {
  return {
    types: [CLEAR_EMAIL_REVISION, CLEAR_EMAIL_REVISION_SUCCESS, CLEAR_EMAIL_REVISION_FAIL],
    promise: client =>
      client.post(`api/emails/resolve/${id}?resolveRelatedRejectedEmails=true`)
  }
}


export function emailRevisionAction (id, data) {
  return {
    types: [EMAIL_REVISION_ACTION, EMAIL_REVISION_ACTION_SUCCESS, EMAIL_REVISION_ACTION_FAIL],
    promise: client =>
      client.post(`api/emails/action/${id}`, {
        data
      })
  }
}
